<template>
  <div class="lang-menu">
    <v-menu transition="scale-transition" :nudge-width="40">
      <template v-slot:activator="{ on }">
        <v-toolbar-title v-on="on">
          <a href="javascript:void(0)" class="white--text font-weight-regular">{{languageLabel}}</a>
          <v-icon dark>arrow_drop_down</v-icon>
        </v-toolbar-title>
      </template>
      <v-list class="py-0">
        <v-list-item
          v-for="(language,key) in topbarArea.Language_List"
          :key="key"
          @click="changeLanguage(language)"
        >
          <img :src="language.Language_Image" class="mr-2" width="24" height="24" />
          <span>{{language.Language_Name}}</span>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify, {
  rtl: true
});
export default {
  props: ["topbarArea"],
  data() {
    return {
      languageLabel:localStorage.languageLabel ? localStorage.languageLabel :"English"
    };
  },
  computed: {
    ...mapGetters(["selectedLocale"])
  },
  methods: {
    changeLanguage(language) {
      var self = this;
      self.languageLabel = language.Language_Name;
      localStorage.setItem("languageLabel", self.languageLabel);
      if (language.Language_Code == "ar") {
        localStorage.setItem("Language", language.Language_Code);
        this.$vuetify.rtl = true;
        localStorage.setItem("direction", "rtl");
      } else {
        localStorage.setItem("Language", language.Language_Code);
        this.$vuetify.rtl = false;
        localStorage.setItem("direction", "ltr");
      }

      // self.$emit("languageChange");
      this.$i18n.locale = language.locale;
      this.$store.dispatch("changeLanguage", language);
    },
    mounted() {
      if (localStorage.getItem("Language") == "ar") {
        this.$vuetify.rtl = true;
      }
    }
  },
  mounted() {
    if (localStorage.getItem("direction") == "rtl") {
      this.$vuetify.rtl = true;
    } else {
      this.$vuetify.rtl = false;
    }
  }
};
</script>